import React, { useEffect } from 'react';
import DisplayRequestLetterStudentLoan from './DisplayRequestLetterStudentLoan';
import DisplayApprovedOfferLetter from './DisplayApprovedOfferLetter';
import DisplayApprovedOfferLetterThirdParty from './DisplayApprovedOfferLetterThirdParty';
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import baseUrl from '../../../../../../BaseURL';
import { Getrequest, Postrequest } from '../../../../../../context/AxiosRequest';



  const DisplayBothLetters = ({ user_tokens, from, typeForUser }) => {


    
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [acceptLoading, setAcceptLoading] = useState(true);
    const [FinalDisbursementLetter, setFinalDisbursementLetter] = useState(null);
    const [reload, setReload] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const showList = ["disbursedone","readydisburs","Disbursement_Approved"];


    useEffect(() => {
     


         async function fetchData() {    
          
                    const response = await Getrequest(`/auth/get_loan_steps/${user_tokens}`);
                    const response2 = await Getrequest(`/auth/get_disbursement_requests_submit_file/${user_tokens}`);

                     if(response[0]?.done === "accepted_disbursement"){

                         setAcceptLoading("accepted");
                     }else{
                        setAcceptLoading(false);
                     }

                     

                    if(response2 && response2.length > 0){
                      setFinalDisbursementLetter(response2[0]);
                      setLoading("done");
                    }else{
                      setFinalDisbursementLetter(null);
                      setLoading(false);
                    } 
              
         }
 
         fetchData();



    }, [reload]);

    const handleFileChange = (e) => {
      setFile(e.target.files[0]);
    };

    const handleAcceptLetter = async () => {
      try {
        setAcceptLoading(true);
        const response = await axios.post(`${baseUrl}/auth/accepted_disbursement`, {
          user_token: user_tokens,
        });

          if(response.data.status){
            toast.success(response.data.textStatus);
            setReload(!reload);
          }else{
            toast.error(response.data.textStatus);
            setReload(!reload);
          }
       
      } catch (error) {
        console.error('Error accepting letter:', error);
        toast.error('Failed to accept letter');
      } finally {
        setAcceptLoading(false);
      }
    };

    const handleDisbursed = async () => {
    
     

      try {

        setLoading(true);

         
        const response = await Postrequest(`/auth/final_letter_offer`, {user_token:user_tokens})
         


         if(!response.status){
          toast.error(response.textStatus);
           setReload(!reload);
          return;
         }else{
          setFile(null);
          toast.success(response.textStatus);
          setReload(!reload);   
          return;
         }
        


      } catch (error) {
        console.error('Error submitting disbursement:', error);
        toast.error('Failed to submit disbursement');
      } finally {
        setLoading(false);
      }
    };
  return (
    <div style={{ 
      display: 'flex', 
      width: '100%', 
      height: '100vh',
      gap: '0'
    }}>
      {/* First Letter - 50% width */}
      <div style={{ 
        width: '50%', 
        height: '100%',
        overflow: 'auto',
        borderRight: '1px solid #ccc'
      }}>
   
        {
           showList.includes(typeForUser) ?
            <h1 className='text-4xl text-center text-white bg-green-950'>Letter From Kadsslb</h1>
            :
             <h1 className='text-4xl text-center text-white bg-green-950'>Letter to Bank  {typeForUser}</h1>
        }
        
        { (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            flexDirection: 'column',
            height: '100%',
            color: '#666'
          }}>
            
            <DisplayRequestLetterStudentLoan typeForUser={typeForUser} type="disbursement-submission" from={from} user_tokens={user_tokens} />
          </div>
        )}
      </div>
         
       {showList.includes(typeForUser) && (
          <div style={{ 
            width: '50%', 
            height: '100%',
            overflow: 'auto'
          }}>
            <h1 className='text-4xl text-center text-white bg-blue-950'>Approved Loan Offer Letter</h1>
            
            {from === "thirdparty" ? (
              <DisplayApprovedOfferLetterThirdParty user_tokens={user_tokens} from={from} />
            ) : (
              <DisplayApprovedOfferLetter user_tokens={user_tokens} from={from} />
            )}
            
         <div style={{ 
              padding: '20px', 
              backgroundColor: '#f0f0f0',
              borderTop: '1px solid #ccc'
            }}>
             
              <div style={{ marginTop: '20px' }}>
               
             
                <button 
                  onClick={handleAcceptLetter}
                  disabled={acceptLoading === "accepted" ? true : acceptLoading}
                  style={{ 
                    padding: '10px 20px',
                    backgroundColor: acceptLoading === "accepted" ? '#ccc' : '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: acceptLoading === "accepted" ? 'not-allowed' : 'pointer',
                    fontWeight: 'bold',
                    display: 'block',
                    width: '100%',
                    marginBottom: '10px'
                  }}
                >
                  {acceptLoading === "accepted" ? 'Accepted' : (acceptLoading ? 'Accepting...' : 'Accept Letter')}
                </button>

                <button 
                  onClick={handleDisbursed}
               //   disabled={loading === "done" ? true : false}
                  style={{ 
                    padding: '10px 20px',
                    backgroundColor: loading === "done" ? '#ccc' : '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: loading === "done" ? 'not-allowed' : 'pointer',
                    fontWeight: 'bold',
                    display: 'block',
                    width: '100%'
                  }}
                >
                  {loading === "done" ? 'Submitted' : (loading ? 'Submitting...' : 'Submit Final Disbursement Letter & Notify Applicant')}
                </button>
              </div>

             
            {/*   {FinalDisbursementLetter && (
                <div style={{ 
                  marginTop: '30px',
                  padding: '20px',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  border: '1px solid #ccc'
                }}>
                  <button 
                    onClick={() => setShowDialog(true)}
                    style={{ 
                      padding: '10px 20px',
                      backgroundColor: '#17a2b8',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      display: 'block',
                      width: '100%'
                    }}
                  >
                    View File Letter Sent to Applicant
                  </button>
                </div>
              )} */}
            </div>   

            
          </div>
              )}

      {
        !showList.includes(typeForUser) &&
      <div style={{ 
        width: '50%', 
        height: '100%',
        overflow: 'auto'
      }}>

          <h1 className='text-4xl text-center bg-red-950 text-white'>Letter From Applicant</h1>
        {(
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100%',
            color: '#666'
          }}>
           <DisplayRequestLetterStudentLoan typeForUser={typeForUser}  type="student-submission" user_tokens={user_tokens} from={from} />
          </div>
        )}
      </div>
      }

      {/* Document Viewer Dialog */}
      {showDialog && FinalDisbursementLetter && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            width: '90%',
            height: '90%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}>
            {/* Dialog Header */}
            <div style={{
              padding: '20px',
              borderBottom: '1px solid #ccc',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: '#f8f9fa'
            }}>
              <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                Final Disbursement Letter
              </h2>
              <button 
                onClick={() => setShowDialog(false)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}
              >
                ✕ Close
              </button>
            </div>
            
            {/* Document Viewer */}
            <div style={{
              flex: 1,
              overflow: 'hidden',
              padding: '10px'
            }}>
              <iframe
                src={`${baseUrl}/get_doc/${FinalDisbursementLetter.file_name}`}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: '4px'
                }}
                title="Final Disbursement Letter"
              />
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default DisplayBothLetters;
